import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { useRouter, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

export const useErrorHandling = ({ reset }: { reset: () => void }) => {
  const router = useRouter();
  const erroredRouteIds = useRouterState({
    select: (s) => s.matches.filter((m) => m.status === 'error').map((m) => m.routeId),
  });
  const isRouteError = erroredRouteIds.length > 0;
  const handleRetryClick = () => {
    // Reset queries on-demand
    queryErrorResetBoundary.reset();
    if (isRouteError) {
      // Invalidate the route to reload the loader, and reset any router error boundaries
      return router.invalidate({ filter: (m) => erroredRouteIds.includes(m.routeId) });
    }
    // Reset the error boundary whether it comes from a router error boundary or custom error boundary
    return reset();
  };

  /** @link https://tanstack.com/router/latest/docs/guide/external-data-loading#error-handling-with-tanstack-query */
  const queryErrorResetBoundary = useQueryErrorResetBoundary();

  // Automatically reset queries passively first in case there are navigation changes
  useEffect(() => {
    queryErrorResetBoundary.reset();
  }, [queryErrorResetBoundary]);

  return { handleRetryClick };
};
